import { Component, OnInit } from '@angular/core';
import { AnnoncenewService } from '../service/annoncenew.service';
import { Annonce } from '../models/annonce.model';
import { PaginatedResponse, PaginationParams } from '../models/pagination.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listnewannonce',
  templateUrl: './listnewannonce.component.html',
  styleUrls: ['./listnewannonce.component.scss']
})
export class ListnewannonceComponent implements OnInit {
  
  annonces: Annonce[] = [];
  
  paginationParams: PaginationParams = {
    page: 0,
    size: 10,
    sortBy: 'createdAt',
    sortDirection: 'desc'
  };
  
  totalItems = 0;
  pageSize = 10;
  pageSizeOptions = [5, 10, 20, 50];
  
  filterForm: FormGroup;
  searchTerm = '';
  isLoading = false;
  
  approvedCount = 0;
  pendingCount = 0;
  
  constructor(
    private annonceService: AnnoncenewService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private router:Router
  ) {
    this.filterForm = this.fb.group({
      ville: [''],
      typeAnnonce: [''],
      isApproved: ['']
    });
  }

  ngOnInit(): void {
    this.loadAnnonces();
  }

  loadAnnonces(): void {
    this.isLoading = true;
    
    const params: PaginationParams = {
      ...this.paginationParams,
      search: this.searchTerm || undefined,
      ville: this.filterForm.get('ville')?.value || undefined,
      typeAnnonce: this.filterForm.get('typeAnnonce')?.value || undefined,
      isApproved: this.filterForm.get('isApproved')?.value !== '' ? this.filterForm.get('isApproved')?.value : undefined
    };

    this.annonceService.getPaginatedAnnonces(params).subscribe({
      next: (response: PaginatedResponse<Annonce>) => {
        this.annonces = response.content;
        this.totalItems = response.totalItems;
        this.calculateStats();
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading annonces:', error);
        this.snackBar.open('Error loading annonces', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
        this.isLoading = false;
      }
    });
  }

  calculateStats(): void {
    this.approvedCount = this.annonces.filter(a => a.isApproved).length;
    this.pendingCount = this.annonces.filter(a => !a.isApproved).length;
  }

  onPageChange(event: PageEvent): void {
    this.paginationParams.page = event.pageIndex;
    this.paginationParams.size = event.pageSize;
    this.pageSize = event.pageSize;
    this.loadAnnonces();
  }

  applyFilters(): void {
    this.paginationParams.page = 0;
    this.loadAnnonces();
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.filterForm.reset();
    this.paginationParams.page = 0;
    this.loadAnnonces();
  }

  searchAnnonces(): void {
    this.paginationParams.page = 0;
    this.loadAnnonces();
  }

  toggleApprovalStatus(annonce: Annonce): void {
    const newStatus = !annonce.isApproved;
    const confirmed = confirm(
      `Are you sure you want to ${newStatus ? 'approve' : 'disapprove'} "${annonce.annonceName}"?`
    );

    if (confirmed) {
      this.isLoading = true;
      this.annonceService.updateApprovalStatus(annonce.id!, newStatus).subscribe({
        next: (updatedAnnonce) => {
          annonce.isApproved = updatedAnnonce.isApproved;
          this.calculateStats();
          this.snackBar.open(
            `Annonce ${newStatus ? 'approved' : 'disapproved'} successfully!`,
            'Close',
            { duration: 3000, panelClass: ['success-snackbar'] }
          );
          this.isLoading = false;
          
          // Add animation class for visual feedback
          const badgeElement = document.querySelector(`[data-annonce-id="${annonce.id}"]`);
          if (badgeElement) {
            badgeElement.classList.add('status-changed');
            setTimeout(() => {
              badgeElement.classList.remove('status-changed');
            }, 500);
          }
        },
        error: (error) => {
          console.error('Error updating status:', error);
          this.snackBar.open('Error updating status', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
          this.isLoading = false;
        }
      });
    }
  }

  getStatusBadge(status: boolean | undefined): string {
    return status ? 'Approved' : 'Pending';
  }

  getTypeColor(type: string): string {
    const colors: { [key: string]: string } = {
      'Vente': '#2196f3',
      'Location': '#4caf50',
      'Echange': '#ff9800',
      'Autre': '#9c27b0'
    };
    return colors[type] || '#757575';
  }

  getImageUrl(imagePath: string | undefined): string {
    if (!imagePath) return 'assets/images/default-annonce.jpg';
    return imagePath.startsWith('http') ? imagePath : `https://app.titv-store-api.com${imagePath}`;
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Copied to clipboard!', 'Close', {
        duration: 2000,
        panelClass: ['info-snackbar']
      });
    });
  }

  getStatusIcon(isApproved: boolean | undefined): string {
    return isApproved ? 'check_circle' : 'pending';
  }
  goToEditAnnonce(id: number): void {
  this.router.navigate(['/editNewAnnonce', id]);
}

}